import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import UserSidebar from "../../Component/UserSidebar";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import * as settingActions from "../../actions/settingActions";
import * as userAction from "../../actions/userActions";
import * as baseActions from "../../actions/baseActions";
import UpdateProfileStep1 from "./UpdateProfileStep1";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { loadUpdateProfileData } from "./Slice/updateProfile1Slice";

// Move functions to outer scope
function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

const UpdateProfile1 = (props) => {
  const { title, actions, updateProfileData, userInfo, setting } = props;
  const dispatch = useDispatch();
  const [popupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [mantees, setMantees] = useState(
    updateProfileData?.number_of_mantees || ""
  );
  console.log("", mantees);
  useEffect(() => {
     document.title = title ?? 'ManageProfile';
  }, [title, setting]);

  useEffect(() => {
    if (userInfo?.id) {
      dispatch(
        loadUpdateProfileData({
          userId: userInfo.id,
          actions,
        })
      );
    }
  }, [dispatch, userInfo?.id, actions]);

  useEffect(() => {
    if (updateProfileData?.number_of_mantees) {
      setMantees(updateProfileData?.number_of_mantees);
    }
  }, [updateProfileData?.number_of_mantees]);

  // Create stable callback functions to prevent destroy errors
  const getUserProfileCallback = useCallback(() => {
    if (userInfo?.id && actions?.getUserProfile) {
      actions.getUserProfile(userInfo.id);
    }
  }, [userInfo?.id, actions]);

  const getSettingsAndProgramsCallback = useCallback(() => {
    if (actions?.getSettingData && actions?.getAllProgrammes) {
      actions.getSettingData();
      actions.getAllProgrammes();
    }
  }, [actions]);

  useEffect(() => {
    getUserProfileCallback();
  }, [getUserProfileCallback]);

  useEffect(() => {
    getSettingsAndProgramsCallback();
  }, [getSettingsAndProgramsCallback]);

  const moduleRenderData = setting?.module_data;

  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name === name && item?.status === "Enabled" && item?.is_default === "Yes");
  };

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />

        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          <h1 className="dash_heading mb-3">Complete/ Edit Profile</h1>

          <div className="box shadow bg-white p-4">
            {setting?.is_sso_enable !== "1" && isSectionShow('Change Password') && (
              <div className="changepassword text-end">
                <Link to="/change-password" className="btn">
                  Change Password
                </Link>
              </div>
            )}
            <div className="studentformdashboard">
              <UpdateProfileStep1 
                type='profile' 
                title={title}
                superUserParams={{}}
              />
            </div>
          </div>
        </div>
      </div>

      <button
        className="sidebar_overlay"
        onClick={SidebarRemoveClass}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            SidebarRemoveClass();
          }
        }}
        aria-label="Close sidebar overlay"
      />

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
};


function mapStateToProps(state) {
  return {
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userAction, ...settingActions, ...baseActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfile1);

UpdateProfile1.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.shape({
    getUserProfile: PropTypes.func,
    getSettingData: PropTypes.func,
    getAllProgrammes: PropTypes.func,
  }),
  updateProfileData: PropTypes.shape({
    number_of_mantees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    language: PropTypes.string,
  }),
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  setting: PropTypes.shape({
    module_data: PropTypes.array,
    is_sso_enable: PropTypes.string,
  }),
};
